import React, { useEffect, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { FretePorPesoCubagem } from "./FretePorPesoCubagem"
import microuniversoApi from 'app/api/microuniversoApi'
import { FreteApi } from "app/api/classes/FreteApi"
import { useAppSelector } from "app/redux/hooks"
import * as R from 'ramda'
import { IItemOrcamento } from "app/types/IItemOrcamento"
import { DadosFreteProduto, TipoFreteDisponivel } from "./tipos"
import { Parametro } from "app/types/Parametro"
import { obterParametros } from "app/use-cases/parametro/obterParametros"
import globalMU from "globalMU"
import {forEachSeries, map, mapSeries} from 'p-iteration'
import { alterarFreteItemOrcamento } from "app/use-cases/orcamento/alterarFreteItemOrcamento"
import { atualizarOrcamento } from "app/use-cases/orcamento/atualizarOrcamento"
import { alterarDataPrevisaoEntregaItem } from "app/use-cases/orcamento/alterarDataPrevisaoEntregaItem"
import { format } from "date-fns"
import { DataFormatoEN } from "app/types/DataFormatoEN"
import { substituirItemEmArray } from "substituirItemEmArray"
import store from "app/redux/store/store"
import { alterarTipoFreteVariosItensOrcamento } from "app/use-cases/orcamento/alterarTipoFreteVariosItensOrcamento"

export type FretePorPesoCubagemContainerProps = {

}

export const FretePorPesoCubagemContainer = (props: FretePorPesoCubagemContainerProps) => {

    const [tiposFrete, setTiposFrete] = useState<FreteApi.BuscarTiposFreteAtivosRespostaItem[]>([])
    const [parametros, setParametros] = useState<Parametro[]>([])
    const [produtos, setProdutos] = useState<DadosFreteProduto[]>([])
    const [idFreteGeralSelecionado, setIdFreteGeralSelecionado] = useState<number>(null)
    const [parametrosCarregados, setParametrosCarregados] = useState(false)

    const orcamento = useAppSelector(state => state.orcamento)

    const valorParametro = (nome:string) => parametros.find(p => p.Nome == nome)?.Valor

    const atualizarParametros = async () => {
        setParametros(
            await obterParametros({
                nomes: [
                    "CHAVE_MOVIMENTACAO_ORCAMENTO",
                    "TRABALHA_MULTIPLOS_TIPOS_FRETES_ENTREGAS"
                ]
            })
        )

        //setParametrosCarregados(true)


    }

    const atualizarTiposFrete = async () => {
        try {
            globalMU.blockUI()

            setTiposFrete(
                await microuniversoApi.Frete.buscarTiposFreteAtivos()
            )

        } finally {
            globalMU.unblockUI()
        }
    }

    const converterItemOrcamentoParaProduto = async (item: IItemOrcamento) : Promise<DadosFreteProduto> => ({
        codigoOuReferencia: valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? item.Codigo : item.ReferenciaProduto,
        dataPrevista: item.DataPrevisaoEntrega,
        descricao: item.Descricao,
        idTipoFrete: globalMU.isNotNullOrZero(item.IdTipoFrete) ? item.IdTipoFrete : item.IdFreteEspecial,
        ehFreteEspecial: globalMU.isNotNullOrZero(item.IdFreteEspecial),
        quantidade: item.Quantidade,
        identificadorItem: item.Identificador,
        descricaoInconsistenciaFrete: item.DescricaoInconsistenciaFrete,
        valorFreteUnitario: item.ValorFreteUnitario,
        tiposFrete: await mapSeries(
            await microuniversoApi.Orcamento.buscarTiposFretesDisponiveis(orcamento.IdentificadorOrcamento, item.Identificador),
            async tipoFreteDisponivel => ({
                Id: tipoFreteDisponivel.IdTipoFrete,
                EhFreteEspecial: tipoFreteDisponivel.EhFreteEspecial,
                Descricao: tipoFreteDisponivel.Descricao
            } as TipoFreteDisponivel)
        )

    })

    const atualizarDadosDeTodosItens = async () => {
        try {
            globalMU.blockUI()
            
            const itens = (store.getState().orcamento.ItensOrcamento ?? []).filter(i => i.TipoEntrega == "Futura")
            
            setProdutos(await map(itens,converterItemOrcamentoParaProduto))

            
        } finally {
            globalMU.unblockUI()
        }
        
        
    }

    const atualizarDadosDeUmItem = async (identificador:number) => {
        try {
            globalMU.blockUI()

            const item = store.getState().orcamento.ItensOrcamento.find(i => i.Identificador == identificador)

            setProdutos(globalMU.substituirItemEmArray(
                produtos,
                p => p.identificadorItem == identificador,
                await converterItemOrcamentoParaProduto(item)
            ))

        } finally {
            globalMU.unblockUI()
        }
    }

    const tipoFreteAlterado = async (identificadorItem:number, idTipoFreteOuFreteEspecial:number, ehFreteEspecial: boolean) => {
        try {
            globalMU.blockUI()
            
            await alterarFreteItemOrcamento({
                identificadorItem, 
                idTipoFreteOuFreteEspecial,
                ehFreteEspecial
            })

            const item = (store.getState().orcamento.ItensOrcamento ?? []).find(i => i.Identificador == identificadorItem)

            setProdutos(globalMU.substituirItemEmArray(
                produtos,
                p => p.identificadorItem == identificadorItem, 
                await converterItemOrcamentoParaProduto(item)))

            
        } finally {
            globalMU.unblockUI()
        }
        
    }

    const tipoFreteAlteradoParaTodosItens = async (idTipoFreteComum:number) => {
        try {

        globalMU.blockUI({tryPassiveLoading: false})
        
        setIdFreteGeralSelecionado(idTipoFreteComum)

        const itensComEntregaFutura = (orcamento.ItensOrcamento ?? []).filter(i => i.TipoEntrega == "Futura")

        const dadosParaProcessar = itensComEntregaFutura.reduce<{itensParaAlterarTipoFrete: IItemOrcamento[], itensParaRemoverTipoFrete: IItemOrcamento[]}>((acc,item) => {
            const obterDadosFreteDoProduto = () : DadosFreteProduto => {
                return produtos.find(p => valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? (item.Codigo == p.codigoOuReferencia) : (item.ReferenciaProduto == p.codigoOuReferencia))
            }

            const produtoJaEstaAssociadoAUmFreteEspecial = () => {
                const produto = obterDadosFreteDoProduto()

                return produto.ehFreteEspecial
            }

            const esteFreteEstaDisponivelParaOProduto = () => {
                const produto = obterDadosFreteDoProduto()

                return (produto?.tiposFrete ?? []).some(tf => tf.Id == idTipoFreteComum)
            }

            if (produtoJaEstaAssociadoAUmFreteEspecial()) {
                return acc
            }

            if (esteFreteEstaDisponivelParaOProduto()) {
                acc.itensParaAlterarTipoFrete = R.append(item,acc.itensParaAlterarTipoFrete)

                return acc
            }

            if (!esteFreteEstaDisponivelParaOProduto() && valorParametro("TRABALHA_MULTIPLOS_TIPOS_FRETES_ENTREGAS") != "S") {

                acc.itensParaRemoverTipoFrete = R.append(item, acc.itensParaRemoverTipoFrete)

                
            }

            return acc
        },{
            itensParaAlterarTipoFrete: [],
            itensParaRemoverTipoFrete: []
        })

        const obterCodigoOuReferencia = (item:IItemOrcamento) => {
            return valorParametro("CHAVE_MOVIMENTACAO_ORCAMENTO") == "C" ? item.Codigo : item.ReferenciaProduto
        }

        dadosParaProcessar.itensParaRemoverTipoFrete.forEach(item => globalMU.showWarnMessage(`Tipo de frete selecionado não é permitido para o(s) produto(s): [${obterCodigoOuReferencia(item)}] - [${item.Descricao}]`))

        const identificadoresItensParaAlterarTipoFrete = dadosParaProcessar.itensParaAlterarTipoFrete.map(i => i.Identificador)

        await alterarTipoFreteVariosItensOrcamento({
            identificadoresItens: identificadoresItensParaAlterarTipoFrete,
            idTipoFreteOuFreteEspecial: idTipoFreteComum,
            ehFreteEspecial: false
        })

        await atualizarDadosDeTodosItens()

        await atualizarOrcamento()

        } finally {
            globalMU.unblockUI()
        }


    }

    const dataPrevistaAlterada = async (identificadorItem:number, novaData:DataFormatoEN) => {
        try {
            globalMU.blockUI()
            
            await alterarDataPrevisaoEntregaItem({
                dataPrevisaoEntrega: novaData,
                identificadorItem: identificadorItem
            })
    
            await atualizarOrcamento()

            await atualizarDadosDeUmItem(identificadorItem)

        } finally {
            globalMU.unblockUI()
        }
    }

    const tipoDeFretePodeSerExibidoParaSelecaoGeral = (tipoFrete: TipoFreteDisponivel) : boolean => {
        const existeAlgumProdutoComEsteFrete = () => (produtos ?? []).some(produto => (produto.tiposFrete ?? []).some(tipoFreteProduto => tipoFrete.Id == tipoFreteProduto.Id && tipoFrete.EhFreteEspecial == tipoFreteProduto.EhFreteEspecial))

        return existeAlgumProdutoComEsteFrete()
    }

    useEffect(() => {
        atualizarParametros().then(atualizarTiposFrete)
    }, [])
    
    useEffect(() => {
        if (parametrosCarregados) {
            atualizarDadosDeTodosItens()
        }

    },[parametrosCarregados])

    useEffect(() => {
        if (parametros?.length > 0) {
            setParametrosCarregados(true)
        }

    },[parametros])


    return <>
        <Breadcrumb2Container
            passos={["Frete por Peso/Cubagem"]}
            id="FretePorPesoCubagemBreadcrumb"
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={false}
            onBotaoLimparClicado={() => {}}/>

        <FretePorPesoCubagem 
            somenteLeitura={orcamento.SomenteLeitura || globalMU.isNotNullOrEmpty(orcamento.CodigoDAV)}
            exibirSomenteFreteEspecialSeHouver={valorParametro("TRABALHA_MULTIPLOS_TIPOS_FRETES_ENTREGAS") != "S"}
            permitirSelecaoDeTipoDeFretePorItem={valorParametro("TRABALHA_MULTIPLOS_TIPOS_FRETES_ENTREGAS") == "S"}
            chaveMovimentacaoOrcamento={"CODIGO"} 
            dadosFreteProdutos={produtos} 
            numeroCasasDecimaisQuantidade={3} 
            numeroCasasDecimaisPreco={2} 
            totalDoFrete={orcamento.ValorFrete} 
            onTipoFreteModificado={(identificadorItem, idTipoFrete, ehFreteEspecial) => tipoFreteAlterado(identificadorItem, idTipoFrete, ehFreteEspecial)} 
            tiposDeFreteDisponiveis={(tiposFrete ?? []).filter(tipoDeFretePodeSerExibidoParaSelecaoGeral)} 
            onTipoFreteModificadoParaTodosItens={tipoFreteAlteradoParaTodosItens}
            onDataPrevistaModificada={dataPrevistaAlterada}
            idFreteGeralSelecionado={idFreteGeralSelecionado}
            />
    </>
}